import { render, staticRenderFns } from "./LancarNotasPage.vue?vue&type=template&id=0f12b246"
import script from "./LancarNotasPage.vue?vue&type=script&lang=js"
export * from "./LancarNotasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports